import React from "react";
import {
  Stack,
  Checkbox,
  Text,
  Card,
  Flex,
  Tag,
  TagLabel,
} from "@chakra-ui/react";
import { t } from "i18next";
import { ApiClientScope } from "../../../models/ApiClient";

const i18prefix = "account:Integrations.scopes";

interface Props {
  scopes: Set<ApiClientScope>;
  setScopes: React.Dispatch<React.SetStateAction<Set<ApiClientScope>>>;
}

export const ManageScopes: React.FC<Props> = ({ scopes, setScopes }) => {
  return (
    <Card.Root variant="outline" p={3}>
      <Stack>
        <Text fontSize="xs" fontWeight="semibold" textTransform="uppercase">
          {t(`${i18prefix}.title`)}
        </Text>
        <Flex flexWrap="wrap" gap={2}>
          {[...scopes].map((scope, i) => (
            <Tag.Root key={i}>
              <TagLabel mt={1} fontFamily="monospace">
                {scope}
              </TagLabel>
              <Tag.EndElement>
                <Tag.CloseTrigger
                  onClick={() => {
                    setScopes((prev) => {
                      prev.delete(scope);
                      return new Set(prev);
                    });
                  }}
                />
              </Tag.EndElement>
            </Tag.Root>
          ))}
        </Flex>
        {Object.values(ApiClientScope).map((scope) => (
          <Checkbox.Root
            colorPalette="primary"
            size="sm"
            key={scope}
            checked={scopes.has(scope)}
            onCheckedChange={({ checked }) => {
              setScopes((prev) => {
                if (checked) {
                  prev.add(scope);
                } else {
                  prev.delete(scope);
                }
                return new Set(prev);
              });
            }}
          >
            <Checkbox.HiddenInput />
            <Checkbox.Control />
            <Checkbox.Label>{t(`${i18prefix}.values.${scope}`)}</Checkbox.Label>
          </Checkbox.Root>
        ))}
      </Stack>
    </Card.Root>
  );
};
